import React, { Component } from 'react';
import { translate } from 'react-translate';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Button from '@components/Button';
import * as S from './styles';

class AccountSteps extends Component {
  render() {
    const {
      props: {
        t,
        sharedBudget,
        easyAccessReducer: { companyInfo },
      },
    } = this;

    return (
      <S.CardWrapper>
        <>
          {sharedBudget && (
          <div>
            <S.TitleWrapper>
              {' '}
              {companyInfo.name}
              {' '}
              {t('TITLE')}
            </S.TitleWrapper>
            <S.TextWrapper>
              {t('TEXT_1')}
              <S.Tooltip>
                {t('ACCOUNT')}
                <S.TooltipText>{t('TOOLTIP')}</S.TooltipText>
              </S.Tooltip>
              {' '}
              {t('TEXT_2_1')}
              {' '}
              {companyInfo.name}
              {' '}
              {t('TEXT_2_2')}
            </S.TextWrapper>
            <S.ButtonWrapper>
              <Button
                backgroundColor="blue2"
                type="button"
                onClick={this.props.handler}
                fontSize="16px"
                size="EAcustom"
              >
                Próximo
              </Button>
            </S.ButtonWrapper>
          </div>
          )}
        </>
      </S.CardWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    authenticationReducer: state.authenticationReducer,
    easyAccessReducer: state.easyAccessReducer,
  };
}

export default withRouter(connect(mapStateToProps)(translate('AccountSteps')(AccountSteps)));
